<template>
  <Breadcrumbs
      title="Add Dealer"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Dealers', path: '/dealers' },
      { label: 'Add Dealer', path: '/add-dealer' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <addDealerForm/>
    </div>
  </div>
</template>

<script>

import addDealerForm from "@/pages/master_data/dealers/addDealerForm.vue";

export default {
  components: {
    addDealerForm
  }
}

</script>